import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BulkOCRProvider } from "./context/BulkOCRContext";

const theme = createTheme({
  palette: {
    primary: {
      light: "#6faa7f",
      main: "#4B9560",
      dark: "#346843",
      contrastText: "#FFF",
    },
    secondary: {
      light: "#ff985b",
      main: "#FF7F32",
      dark: "#b25823",
      contrastText: "#FFF",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BulkOCRProvider>
        <App />
      </BulkOCRProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
